import { api } from "./api";

export const obtenerTodasLasCategoriasDewey = async () => {
  const { data } = await api.get("/categoriasDewey/all");
  return data;
};

